import { colors } from "@/styles/design-tokens";

export const STORE_ROUTER_URL = "https://storerouter.ai";

export function PoweredByFooter() {
  return (
    <footer
      className="flex w-full justify-center bg-white px-4 py-4"
      style={{ borderTop: `1px solid ${colors.divider.light}` }}
    >
      <p className="text-overline-wide text-center text-black/50">
        Powered by{" "}
        <a
          href={STORE_ROUTER_URL}
          target="_blank"
          rel="noopener"
          className="text-ink underline-offset-2 transition-opacity hover:underline hover:opacity-70"
        >
          StoreRouter.ai
        </a>
      </p>
    </footer>
  );
}
